import { render, staticRenderFns } from "./ClinicAvailability.vue?vue&type=template&id=627f660c"
import script from "./ClinicAvailability.vue?vue&type=script&lang=js"
export * from "./ClinicAvailability.vue?vue&type=script&lang=js"
import style0 from "./ClinicAvailability.vue?vue&type=style&index=0&id=627f660c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports